export const THUMBS = Object.freeze({
  original: 'original',
  replaced: 'e_replaced',
  '380x254': 'e_380x254',
  '840x560': 'e_840x560',
  '840xauto': 'e_840xAuto',
  '1200xauto': 'e_1200xAuto',
})
